import BaseApi from './BaseApi'

class HelperApi extends BaseApi {
  getUserStatuses () {
    return this.get('users/statuses')
  }

  getStates () {
    return this.get('countries/states')
  }

  getLanguages () {
    return this.get('languages')
  }

  getCities (config) {
    let suffix = Object.keys(config)
      .map(key => `${key}=${config[key]}`)
      .join('&')

    return this.get(`cities${suffix ? '?' + suffix : ''}`)
  }

  getCity (id) {
    return this.get(`city/${id}`)
  }

  createDemoTimesheet (fileName, dataObj) {
    const url = `demo/timeSheets`
    const method = 'post'
    return this.downloadAsFile(
      { url, method, data: dataObj },
      'application/pdf',
      fileName
    )
  }

  sendContactData (data) {
    return this.post(`contact`, data)
  }
}

export default new HelperApi()
